export default "__VITE_ASSET__36edb81c__"